/**
 * TTS for user-facing "listen" flows should hit /api/ai/speak (ElevenLabs + server disk cache).
 * Enable browser Speech Synthesis only as a fallback when the API fails — useful for local dev
 * without ELEVENLABS_API_KEY.
 *
 * Build: REACT_APP_READ_ALOUD_BROWSER_FALLBACK=true
 * Runtime: window.__ENV__.REACT_APP_READ_ALOUD_BROWSER_FALLBACK in public/env.js
 */
export function readAloudBrowserFallbackAllowed() {
  if (typeof window === "undefined") return false;
  const r = window.__ENV__?.REACT_APP_READ_ALOUD_BROWSER_FALLBACK;
  if (r === true || String(r).toLowerCase() === "true" || r === "1") return true;
  return process.env.REACT_APP_READ_ALOUD_BROWSER_FALLBACK === "true";
}
